import { useGetGolfEventSummaryQuery } from '../state/api';
import { selectEventById } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import TourEventOverview from './tour-event-overview';

interface TourEventOverviewContainerProps {
  eventID: string;
}

const TourEventOverviewContainer = ({ eventID }: TourEventOverviewContainerProps) => {
  // Fetch data with RTK Query (handles caching, loading states)
  useGetGolfEventSummaryQuery();

  // Use entity selector for O(1) lookup by ID (no more useMemo or array.find!)
  const event = useAppSelector((state) => selectEventById(state, eventID));

  return <TourEventOverview event={event} />;
};

export default TourEventOverviewContainer;
